exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tag-input[data-v-692cf798] {\n  width: 100%;\n  border: 1px solid #eee;\n  font-size: 0.9em;\n  min-height: 50px;\n  box-sizing: border-box;\n  padding: 0 10px;\n}\n.tag-input__tag[data-v-692cf798] {\n  height: 30px;\n  float: left;\n  margin-right: 10px;\n  background-color: #eee;\n  margin-top: 10px;\n  line-height: 30px;\n  padding: 0 5px;\n  border-radius: 5px;\n}\n.tag-input__tag > span[data-v-692cf798] {\n  cursor: pointer;\n  opacity: 0.75;\n}\n.tag-input__text[data-v-692cf798] {\n  border: none;\n  outline: none;\n  font-size: 0.9em;\n  line-height: 50px;\n  background: none;\n}\n", ""]);

// exports
